/* Fiche produit v2, Polar Star.
 *
 * v64 (24/10/2026) : copie de ps-fiche-v2-v59.js sous un NOM NEUF (cache CDN) ; le rafraîchissement du compteur du panier
 * ne désemballe plus l'icône (voir rafraichirCompteur). Le prix affiché n'est pas le plein tarif : c'est ce que
 * CETTE paire coûtera une fois ajoutée, au palier atteint. Le tiroir lit le vrai panier.
 *
 * v46 (15/10/2026) : pt et pl ajoutés (alias pt-PT vers pt, pluriel polonais à trois formes par motDe), copie de v43 sous un NOM NEUF.
 *
 * v43 (14/10/2026, Nicolas) : copie de ps-fiche-v2-v40b.js sous un NOM NEUF (cache CDN). UNE SEULE GRILLE pour toute
 * la boutique : 3 et 4 paires → -20 %, 5 et 6 → -30 %, 7 à 9 → -40 %, 10 et plus → -50 %. Chaque prix suit Shopify :
 * la remise se retire PAIRE PAR PAIRE, arrondie au centime inférieur (prix - floor(prix x taux)).
 * Livraison offerte dès 4 ARTICLES en France et Zone 1 (data-franco-art), 60 € en Zone 2 (data-franco). La fiche
 * n'affiche jamais le montant du port (data-port retiré, PORT n'existe plus).
 *
 * ⚠️ Le compte du tiroir prend TOUS les articles du panier. La remise Shopify, elle, porte sur
 * 7 collections qui couvrent tout le catalogue vendable : les deux coïncident aujourd'hui.
 * Le jour où une collection sort du périmètre, ce compte devra la retirer aussi.
 *
 * ⚠️ LE SITE PARLE SIX LANGUES : fr, de, en, es, it, nl (le neerlandais ajoute le 25/09/2026 :
 * il retombait sur T.en, fiche en anglais sur le marche ou tournent les pubs NL).
 * Anciennement : cinq langues, fr, de, en, es, it. La table T n'en connaissait que TROIS
 * jusqu'au 20/09/2026, et T[langue] || T.en faisait silencieusement retomber l'espagnol et
 * l'italien sur l'anglais : une fiche espagnole entièrement traduite côté serveur voyait son
 * bouton, sa ligne de livraison et son message de tiroir réécrits en anglais par ce script.
 * Repéré par Nicolas. Toute nouvelle chaîne s'ajoute dans LES CINQ branches, et motPaire aussi.
 *
 * --- Retour Nicolas du 20/09/2026, changements sur le bloc de prix ---
 * 1. « soit X dans le tiroir » ne s'affiche QUE lorsque le tiroir contient déjà plusieurs
 *    paires, et il annonce alors le prix RÉEL en cours (prixActuel), pas une promesse.
 * 2. La ligne de condition annonce le prix de la PAIRE SUIVANTE, pas le nouveau prix unitaire
 *    de l'ensemble. « La deuxième paire à 11,92 € » se projette, « la deuxième fait passer les
 *    deux à 13,41 € » demande un calcul au lecteur.
 * 3. À six paires la ligne de condition disparaît : il n'y a plus de paire suivante à annoncer.
 */
(function () {
  var racine = document.querySelector('[data-psv2]');
  if (!racine) return;

  /* Le seuil de port offert vient du Liquid, jamais d un nombre ecrit ici : il vaut
     4500 en France et en Zone 1, 6000 en Zone 2 (Suisse, Canada, Etats-Unis...).
     Un chiffre en dur faisait promettre « des 4 paires » a un Suisse qui en paie 6. */
  var FRANCO = parseInt(racine.getAttribute('data-franco') || '0', 10) || 0; // centimes, Zone 2 seulement (v43)
  var FRANCO_ART = parseInt(racine.getAttribute('data-franco-art') || '0', 10) || 0; // v43 : France et Zone 1, en articles
  /* Mode pack (27/09/2026) : un coffret n'a ni prix au palier ni tiroir. Voir ps-fiche-v2.liquid. */
  var PACK = racine.hasAttribute('data-pack');
  var langue = racine.getAttribute('data-langue') || 'en';
  if (langue.slice(0, 2) === 'pt') langue = 'pt'; /* v46 : data-langue vaut pt-PT */
  var famille = racine.getAttribute('data-famille') || 'hiver';
  var plein = parseInt(racine.getAttribute('data-prix-plein') || '0', 10);

  /* Aucune des cinq langues ne tutoie ni ne vouvoie : phrases nominales.
     C'est l'usage des marques françaises sur une fiche produit, et ça évite de trancher
     un registre qui vieillit mal. Depuis le 28/09/2026 (v27, avant le test Google Ads) le
     MONTANT du port est aussi écrit (livSeuilPort, livPack) : « Livraison 4,90€, offerte dès
     45€ (4 paires) ». Avant, la fiche ne donnait que le seuil et le visiteur découvrait les
     4,90 € au paiement. */
  var T = {
    fr: {
      cta: 'Ajouter cette paire',
      effectif: 'soit {x} dans le tiroir',
      taille: 'Taille ',
      modifier: ', modifier',
      choisis: 'Sélectionner une taille',
      livSeuil: 'Livraison offerte dès {k} paires',
      livSeuilPort: 'Livraison {port}, offerte dès {seuil} ({k} paires)',
      livPack: 'Livraison {port}, offerte dès {seuil}',
      livProche: 'Livraison offerte dès la prochaine paire',
      livAcquise: 'Livraison offerte',
      arrivee: 'Arrivée entre le {d} et le {d2}',
      ajoute: 'Ajouté au tiroir',
      erreur: 'Ajout impossible pour le moment. Merci de réessayer.',
      laPaire: ' la paire',
      condition: 'La paire suivante à {sur}.',
      msgVide: 'Le tiroir est vide. Cette paire y a déjà sa place.',
      msgPalier: '{n} {mot} dans le tiroir. Encore {k} pour passer tout le tiroir à {pn} la paire.',
      plein: 'Tiroir plein. {p10} la paire, le meilleur prix. Rien au-dessus.'
    },
    de: {
      cta: 'Dieses Paar hinzufügen',
      effectif: 'also {x} in der Schublade',
      taille: 'Größe ',
      modifier: ', ändern',
      choisis: 'Eine Größe wählen',
      livSeuil: 'Versand ab {k} Paar kostenlos',
      livSeuilPort: 'Versand {port}, kostenlos ab {seuil} ({k} Paar)',
      livPack: 'Versand {port}, kostenlos ab {seuil}',
      livProche: 'Versand ab dem nächsten Paar kostenlos',
      livAcquise: 'Versand kostenlos',
      arrivee: 'Ankunft zwischen {d} und {d2}',
      ajoute: 'Zur Schublade hinzugefügt',
      erreur: 'Hinzufügen gerade nicht möglich. Bitte erneut versuchen.',
      laPaire: ' pro Paar',
      condition: 'Das nächste Paar für {sur}.',
      msgVide: 'Die Schublade ist leer. Dieses Paar hat darin schon seinen Platz.',
      msgPalier: '{n} {mot} in der Schublade. Noch {k}, und die ganze Schublade kostet {pn} pro Paar.',
      plein: 'Schublade voll. {p10} pro Paar, der beste Preis. Mehr geht nicht.'
    },
    en: {
      cta: 'Add this pair',
      effectif: 'that is {x} in the drawer',
      taille: 'Size ',
      modifier: ', change',
      choisis: 'Select a size',
      livSeuil: 'Delivery is on us from {k} pairs',
      livSeuilPort: 'Delivery {port}, free from {seuil} ({k} pairs)',
      livPack: 'Delivery {port}, free from {seuil}',
      livProche: 'Delivery is on us from the next pair',
      livAcquise: 'Delivery is on us',
      arrivee: 'Arriving between {d} and {d2}',
      ajoute: 'Added to the drawer',
      erreur: 'Could not add right now. Please try again.',
      laPaire: ' a pair',
      condition: 'The next pair for {sur}.',
      msgVide: 'The drawer is empty. This pair already has its place in it.',
      msgPalier: '{n} {mot} in the drawer. {k} more and the whole drawer drops to {pn} a pair.',
      plein: 'Drawer full. {p10} a pair, the best price. Nothing above this.'
    },
    es: {
      cta: 'Añadir este par',
      effectif: 'es decir {x} en el cajón',
      taille: 'Talla ',
      modifier: ', cambiar',
      choisis: 'Elegir una talla',
      livSeuil: 'Envío gratis a partir de {k} pares',
      livSeuilPort: 'Envío {port}, gratis a partir de {seuil} ({k} pares)',
      livPack: 'Envío {port}, gratis a partir de {seuil}',
      livProche: 'Envío gratis a partir del próximo par',
      livAcquise: 'Envío gratis',
      arrivee: 'Llega entre el {d} y el {d2}',
      ajoute: 'Añadido al cajón',
      erreur: 'No se ha podido añadir. Vuelve a intentarlo.',
      laPaire: ' el par',
      condition: 'El siguiente par por {sur}.',
      msgVide: 'El cajón está vacío. Este par ya tiene su sitio.',
      msgPalier: '{n} {mot} en el cajón. Con {k} más, todo el cajón baja a {pn} el par.',
      plein: 'Cajón lleno. {p10} el par, el mejor precio. No hay nada mejor.'
    },
    it: {
      cta: 'Aggiungi questo paio',
      effectif: 'ovvero {x} nel cassetto',
      taille: 'Taglia ',
      modifier: ', modifica',
      choisis: 'Scegli una taglia',
      livSeuil: 'Spedizione gratuita da {k} paia',
      livSeuilPort: 'Spedizione {port}, gratuita da {seuil} ({k} paia)',
      livPack: 'Spedizione {port}, gratuita da {seuil}',
      livProche: 'Spedizione gratuita dal prossimo paio',
      livAcquise: 'Spedizione gratuita',
      arrivee: 'Arriva tra {d} e {d2}',
      ajoute: 'Aggiunto al cassetto',
      erreur: 'Aggiunta non riuscita. Riprova.',
      laPaire: ' al paio',
      condition: 'Il paio successivo a {sur}.',
      msgVide: 'Il cassetto è vuoto. Questo paio ha già il suo posto.',
      msgPalier: '{n} {mot} nel cassetto. Con altri {k}, tutto il cassetto scende a {pn} al paio.',
      plein: 'Cassetto pieno. {p10} al paio, il miglior prezzo. Niente di meglio.'
    },
    nl: {
      cta: 'Dit paar toevoegen',
      effectif: 'dus {x} in de lade',
      taille: 'Maat ',
      modifier: ', wijzigen',
      choisis: 'Kies een maat',
      livSeuil: 'Gratis verzending vanaf {k} paar',
      livSeuilPort: 'Verzending {port}, gratis vanaf {seuil} ({k} paar)',
      livPack: 'Verzending {port}, gratis vanaf {seuil}',
      livProche: 'Gratis verzending vanaf het volgende paar',
      livAcquise: 'Gratis verzending',
      arrivee: 'Bezorgd tussen {d} en {d2}',
      ajoute: 'Toegevoegd aan de lade',
      erreur: 'Toevoegen lukt nu niet. Probeer het opnieuw.',
      laPaire: ' per paar',
      condition: 'Het volgende paar voor {sur}.',
      msgVide: 'De lade is leeg. Dit paar heeft er al een plek in.',
      msgPalier: '{n} {mot} in de lade. Nog {k} en de hele lade gaat naar {pn} per paar.',
      plein: 'Lade vol. {p10} per paar, de beste prijs. Beter wordt het niet.'
    },
    pt: {
      cta: 'Adicionar este par',
      effectif: 'ou seja, {x} na gaveta',
      taille: 'Tamanho ',
      modifier: ', alterar',
      choisis: 'Escolher um tamanho',
      livSeuil: 'Portes grátis a partir de {k} pares',
      livSeuilPort: 'Envio {port}, grátis a partir de {seuil} ({k} pares)',
      livPack: 'Envio {port}, grátis a partir de {seuil}',
      livProche: 'Portes grátis a partir do próximo par',
      livAcquise: 'Portes grátis',
      arrivee: 'Chega entre {d} e {d2}',
      ajoute: 'Adicionado à gaveta',
      erreur: 'Não foi possível adicionar agora. Tenta novamente.',
      laPaire: ' o par',
      condition: 'O par seguinte por {sur}.',
      msgVide: 'A gaveta está vazia. Este par já tem o seu lugar.',
      msgPalier: '{n} {mot} na gaveta. Mais {k} e toda a gaveta desce para {pn} o par.',
      plein: 'Gaveta cheia. {p10} o par, o melhor preço. Nada acima disto.'
    },
    pl: {
      cta: 'Dodaj tę parę',
      effectif: 'czyli {x} w szufladzie',
      taille: 'Rozmiar ',
      modifier: ', zmień',
      choisis: 'Wybierz rozmiar',
      livSeuil: 'Darmowa dostawa od {k} par',
      livSeuilPort: 'Dostawa {port}, darmowa od {seuil} (od {k} par)',
      livPack: 'Dostawa {port}, darmowa od {seuil}',
      livProche: 'Darmowa dostawa od następnej pary',
      livAcquise: 'Darmowa dostawa',
      arrivee: 'Przewidywana dostawa: {d}, najpóźniej {d2}',
      ajoute: 'Dodano do szuflady',
      erreur: 'Nie udało się teraz dodać. Spróbuj ponownie.',
      laPaire: ' za parę',
      condition: 'Następna para za {sur}.',
      msgVide: 'Szuflada jest pusta. Ta para ma już w niej swoje miejsce.',
      msgPalier: '{n} {mot} w szufladzie. Jeszcze {k} i cała szuflada spada do {pn} za parę.',
      plein: 'Szuflada pełna. {p10} za parę, najlepsza cena. Nic powyżej.'
    }
  };
  /* ------------------------------------------------------------------------
     LIGNE PILATES. Même mise en page, autres mots, autre seuil de port.
     Posé le 2026-09-20 : la fiche d'une chaussette de Pilates annonçait « Le tiroir
     d'hiver », « Ajouté au tiroir » et « le meilleur prix de l'hiver ».
     ⚠️ ET SURTOUT LE SEUIL DE PORT N'EST PAS LE MÊME. À 18,95 € la paire, trois paires
     remisées font 48,32 € et passent les 45 € de franchise ; à 14,90 € il en faut quatre.
     C'est pour ça que « dès 4 paires » est devenu « dès {k} paires », calculé.
     ------------------------------------------------------------------------ */
  var PILATES = {
    fr: {
      effectif: 'soit {x} dans le sac',
      ajoute: 'Ajouté au sac',
      msgVide: 'Le sac est vide. Cette paire y a déjà sa place.',
      msgPalier: '{n} {mot} dans le sac. Encore {k} pour passer tout le sac à {pn} la paire.',
      plein: 'Sac complet. {p10} la paire, le meilleur prix. Rien au-dessus.'
    },
    de: {
      effectif: 'also {x} in der Tasche',
      ajoute: 'Zur Tasche hinzugefügt',
      msgVide: 'Die Tasche ist leer. Dieses Paar hat darin schon seinen Platz.',
      msgPalier: '{n} {mot} in der Tasche. Noch {k}, und die ganze Tasche kostet {pn} pro Paar.',
      plein: 'Tasche komplett. {p10} pro Paar, der beste Preis. Mehr geht nicht.'
    },
    en: {
      effectif: 'that is {x} in the bag',
      ajoute: 'Added to the bag',
      msgVide: 'The bag is empty. This pair already has its place in it.',
      msgPalier: '{n} {mot} in the bag. {k} more and the whole bag drops to {pn} a pair.',
      plein: 'Bag complete. {p10} a pair, the best price. Nothing above this.'
    },
    es: {
      effectif: 'o sea {x} en la bolsa',
      ajoute: 'Añadido a la bolsa',
      msgVide: 'La bolsa está vacía. Este par ya tiene su sitio dentro.',
      msgPalier: '{n} {mot} en la bolsa. Con {k} más, toda la bolsa baja a {pn} el par.',
      plein: 'Bolsa completa. {p10} el par, el mejor precio. Nada por encima.'
    },
    it: {
      effectif: 'cioè {x} nella borsa',
      ajoute: 'Aggiunto alla borsa',
      msgVide: 'La borsa è vuota. Questo paio ha già il suo posto dentro.',
      msgPalier: '{n} {mot} nella borsa. Con altri {k}, tutta la borsa scende a {pn} al paio.',
      plein: 'Borsa completa. {p10} al paio, il miglior prezzo. Niente al di sopra.'
    },
    nl: {
      effectif: 'dus {x} in de tas',
      ajoute: 'Toegevoegd aan de tas',
      msgVide: 'De tas is leeg. Dit paar heeft er al een plek in.',
      msgPalier: '{n} {mot} in de tas. Nog {k} en de hele tas gaat naar {pn} per paar.',
      plein: 'Tas compleet. {p10} per paar, de beste prijs. Beter wordt het niet.'
    },
    pt: {
      effectif: 'ou seja, {x} no saco',
      ajoute: 'Adicionado ao saco',
      msgVide: 'O saco está vazio. Este par já tem o seu lugar lá dentro.',
      msgPalier: '{n} {mot} no saco. Mais {k} e todo o saco desce para {pn} o par.',
      plein: 'Saco completo. {p10} o par, o melhor preço. Nada acima disto.'
    },
    pl: {
      effectif: 'czyli {x} w torbie',
      ajoute: 'Dodano do torby',
      msgVide: 'Torba jest pusta. Ta para ma już w niej swoje miejsce.',
      msgPalier: '{n} {mot} w torbie. Jeszcze {k} i cała torba spada do {pn} za parę.',
      plein: 'Torba pełna. {p10} za parę, najlepsza cena. Nic powyżej.'
    }
  };

  var t = T[langue] || T.en;
  if (famille === 'pilates') {
    var sup = PILATES[langue] || PILATES.en;
    var fusion = {};
    for (var cle in t) { if (Object.prototype.hasOwnProperty.call(t, cle)) fusion[cle] = t[cle]; }
    for (var cle2 in sup) { if (Object.prototype.hasOwnProperty.call(sup, cle2)) fusion[cle2] = sup[cle2]; }
    t = fusion;
  }

  var el = {
    effectif: racine.querySelector('[data-psv2-effectif]'),
    condition: racine.querySelector('[data-psv2-condition]'),
    livraison: racine.querySelector('[data-psv2-livraison]'),
    cases: racine.querySelectorAll('[data-psv2-cases] .psv2__case'),
    message: racine.querySelector('[data-psv2-message]'),
    ctaTexte: racine.querySelector('[data-psv2-cta-texte]'),
    /* v40 : avec le sélecteur de pack (psm-pack-paires), c'est LUI qui écrit la barre collante (prix et nombre de paires). */
    barrePrix: racine.querySelector('[data-pp]') ? null : racine.querySelector('[data-psv2-barre-prix]'),
    barreTaille: racine.querySelector('[data-pp]') ? null : racine.querySelector('[data-psv2-barre-taille]'),
    erreur: racine.querySelector('[data-psv2-erreur]'),
    compte: racine.querySelector('[data-psv2-compte]'),
    marche: racine.querySelector('[data-psv2-marche]'),
    barreJauge: racine.querySelector('[data-psv2-barre-jauge]'),
    tiroir: racine.querySelector('[data-psv2-tiroir]'),
    jaugeGalerie: racine.querySelector('[data-psv2-jauge-galerie]'),
    galerie: racine.querySelector('.psv2__galerie')
  };
  var vignettes = Array.prototype.slice.call(racine.querySelectorAll('[data-psv2-prix-vignette]'));
  var motPaire = {
    fr: ['paire', 'paires'],
    de: ['Paar', 'Paar'],
    en: ['pair', 'pairs'],
    es: ['par', 'pares'],
    it: ['paio', 'paia'],
    nl: ['paar', 'paar'],
    pt: ['par', 'pares'],
    pl: ['para', 'pary', 'par']
  }[langue] || ['pair', 'pairs'];
  /* v46 : le polonais a trois formes (1 para, 2-4 pary hors 12-14, sinon par). */
  function motDe(n) {
    if (motPaire.length < 3) return n > 1 ? motPaire[1] : motPaire[0];
    var d = n % 10, h = n % 100;
    return n === 1 ? motPaire[0] : (d >= 2 && d <= 4 && (h < 12 || h > 14)) ? motPaire[1] : motPaire[2];
  }
  var pilules = Array.prototype.slice.call(racine.querySelectorAll('[data-psv2-variante]'));
  var boutons = Array.prototype.slice.call(racine.querySelectorAll('[data-psv2-ajouter]'));
  var rapides = Array.prototype.slice.call(racine.querySelectorAll('[data-psv2-rapide]'));

  var etat = { paires: 0, variante: null, prixVariante: plein, images: [], dernierPalier: 0 };

  /* v43 : nouvelle grille, en POURCENTAGE entier (20, 30, 40, 50) pour l'arrondi paire par paire. */
  function remise(n) {
    if (n >= 10) return 50;
    if (n >= 7) return 40;
    if (n >= 5) return 30;
    if (n >= 3) return 20;
    return 0;
  }
  /* Prix d'une paire au palier de n paires, en centimes, arrondi comme Shopify (mesuré au vrai panier le 13/10). */
  function prixPaire(base, n) { return base - Math.floor(base * remise(n) / 100); }

  /* L'anglais met le symbole devant et le point en décimale ; le français, l'allemand,
     l'espagnol et l'italien mettent la virgule et le symbole derrière. */
  /* Combien de paires pour la livraison offerte. v43 : 4 en France et Zone 1 (règle en articles) ; en Zone 2,
     calculé sur le seuil en montant, remise comprise. Inutilisé à l'affichage depuis le 03/10 (v31), gardé. */
  function seuilFranco(base) {
    if (FRANCO_ART) return FRANCO_ART;
    if (!FRANCO) return 0;
    for (var k = 1; k <= 10; k += 1) {
      if (k * prixPaire(base, k) >= FRANCO) return k;
    }
    return 10;
  }

  /* Un seuil rond s'écrit sans centimes : « 45€ », pas « 45,00€ ». */
  function rond(centimes) { return argent(centimes).replace(/[.,]00(?!\d)/, ''); }

  function argent(centimes) {
    var v = centimes / 100;
    if (langue === 'en') return '€' + v.toFixed(2);
    /* Symbole collé au chiffre, demandé par Nicolas le 21/09/2026 : « 15,17€ ».
       L'espace insécable typographique du français est volontairement abandonné ici,
       c'est un choix de marque et il vaut pour tous les prix de la fiche. */
    return v.toFixed(2).replace('.', ',') + '€';
  }

  function remplir(modele, vals) {
    return modele.replace(/\{(\w+)\}/g, function (_, k) { return vals[k] || ''; });
  }

  /* Coffret (27/09/2026) : un script de la page remet le prix principal au format du marché
     (« €38.00 » en anglais, « €38,00 » en néerlandais) mais ne touche ni au prix barré ni au prix
     à la paire, qui restaient en « 44,70€ ». On recopie le format LU sur le prix principal. */
  function alignerFormatPack() {
    var lig = racine.querySelector('.psv2__prix-ligne');
    if (!lig || !lig.firstChild) return;
    var modele = (lig.firstChild.textContent || '').trim();
    var m = /\d+([.,])\d{2}/.exec(modele);
    if (!m) return;
    var comme = function (c) { return modele.replace(/\d+[.,]\d{2}/, (c / 100).toFixed(2).replace('.', m[1])); };
    var barreP = racine.querySelector('.psv2__prix-barre[data-centimes]');
    if (barreP) barreP.textContent = comme(+barreP.getAttribute('data-centimes'));
    var info = racine.querySelector('.psv2__pack-info[data-centimes]');
    if (info) info.textContent = info.textContent.replace(/€\s?\d+[.,]\d{2}|\d+[.,]\d{2}\s?€/, comme(+info.getAttribute('data-centimes')));
  }

  function rendre() {
    var base = etat.prixVariante || plein;
    if (PACK) {
      if (el.effectif) el.effectif.hidden = true;
      if (el.livraison) {
        var porteurP = el.livraison.closest('[data-date]') || el.livraison;
        var dP = porteurP.getAttribute('data-date') || '';
        var d2P = porteurP.getAttribute('data-date2') || dP;
        var dateP = remplir(t.arrivee, { d: '<span class="psv2__date">' + dP + '</span>',
                                         d2: '<span class="psv2__date">' + d2P + '</span>' });
        /* Le seuil de port se juge sur le prix du coffret, pas sur un nombre de paires. */
        /* 03/10/2026 (v31), Nicolas : la fiche ne dit plus le prix du port ni le seuil, seulement QUAND
           ca arrive. Les textes livPack / livAcquise restent dans la table, inutilises. */
        el.livraison.innerHTML = dateP;
      }
      alignerFormatPack();
      setTimeout(alignerFormatPack, 900);
      if (el.ctaTexte) el.ctaTexte.textContent = t.cta;
      if (el.barrePrix) el.barrePrix.textContent = argent(base);
      if (el.barreTaille) {
        var choisieP = pilules.filter(function (p) { return p.getAttribute('aria-pressed') === 'true'; })[0];
        el.barreTaille.textContent = choisieP ? t.taille + choisieP.textContent.trim() + t.modifier : t.choisis;
      }
      return;
    }
    var n = etat.paires;
    var apres = n + 1;
    var prixApres = prixPaire(base, apres);
    var prixActuel = prixPaire(base, n);

    /* v43 : plus de port dans le calcul (la fiche ne montre jamais son montant) : {sur} = ce que coûte en plus
       la paire suivante, remises recalculées sur tout le tiroir. */
    var surcout = Math.max(0, apres * prixApres - n * prixActuel);
    var marginal2 = Math.max(0, 2 * prixPaire(base, 2) - base);
    /* Prochain palier : 3, 5, 7 puis 10. */
    var paliers = [3, 5, 7, 10];
    var cibleP = paliers.filter(function (x) { return x > n; })[0] || 10;

    var vals = {
      p3: argent(prixPaire(base, 3)),
      p5: argent(prixPaire(base, 5)),
      p7: argent(prixPaire(base, 7)),
      p10: argent(prixPaire(base, 10)),
      pn: argent(prixPaire(base, cibleP)),
      k: String(cibleP - n),
      n: String(n),
      mot: motDe(n),
      sur: argent(surcout),
      m2: argent(marginal2)
    };

    /* Le prix de vente affiché en haut ne bouge jamais : c'est le prix du produit.
       Cette ligne dit ce que la paire revient à coûter DANS LE TIROIR TEL QU'IL EST,
       donc elle n'a de sens qu'à partir de deux paires réellement présentes. */
    if (el.effectif) {
      if (remise(n) > 0) {
        var neuf = remplir(t.effectif, { x: argent(prixActuel) });
        if (el.effectif.textContent !== neuf) {
          el.effectif.textContent = neuf;
          el.effectif.removeAttribute('data-bascule');
          void el.effectif.offsetWidth; /* force le redémarrage de l'animation */
          el.effectif.setAttribute('data-bascule', '');
        }
        el.effectif.hidden = false;
      } else {
        el.effectif.hidden = true;
      }
    }
    /* Tiroir plein : plus aucune paire suivante à annoncer. La ligne disparaît,
       le message du tiroir (t.plein) dit déjà le prix atteint. */
    if (el.condition) {
      if (n >= 10) {
        el.condition.textContent = '';
        el.condition.hidden = true;
      } else {
        el.condition.textContent = remplir(t.condition, n ? vals : { sur: vals.m2 });
        el.condition.hidden = false;
      }
    }
    if (el.livraison) {
      /* data-date vit sur le <p> parent : le picto et le texte sont deux enfants. */
      var porteur = el.livraison.closest('[data-date]') || el.livraison;
      var d = porteur.getAttribute('data-date') || '';
      var d2 = porteur.getAttribute('data-date2') || d;
      var kFranco = seuilFranco(base);
      /* v43 : jamais de montant de port, seulement « offerte dès N paires » en positif (inutilisé depuis la v31). */
      var seuil = !kFranco ? '' : (n >= kFranco ? t.livAcquise
                : (n >= kFranco - 1 ? t.livProche : remplir(t.livSeuil, { k: kFranco })));
      /* Deux lignes depuis le 21/09/2026 : le seuil de port, puis la date d arrivee.
         La date passe dans un span colore pour qu on voie tout de suite que c est une
         valeur calculee et pas un texte fige. innerHTML est sans risque ici : la date
         vient de notre propre Liquid, jamais d une saisie. */
      var ligne2 = remplir(t.arrivee, { d: '<span class="psv2__date">' + d + '</span>',
                                        d2: '<span class="psv2__date">' + d2 + '</span>' });
      /* 03/10/2026 (v31), Nicolas : « Livraison 4,90€, offerte dès 45€ (3 paires) » est retire de la
         fiche, dans les six langues. Il ne reste que la date (ou fourchette) d arrivee de la zone.
         Le calcul de seuil ci-dessus est garde (inutilise) pour pouvoir revenir en arriere d une ligne. */
      void seuil;
      el.livraison.innerHTML = ligne2;
    }
    if (el.message) el.message.textContent = n >= 10 ? remplir(t.plein, vals) : (n === 0 ? t.msgVide : remplir(t.msgPalier, vals));
    if (el.ctaTexte) el.ctaTexte.textContent = t.cta;
    if (el.barrePrix) {
      var venteBarre = argent(base);
      /* v64 : la barre des Pilates (data-barre-prix-seul) n'affiche que le prix, sans « la paire » ni prix de palier. */
      if (!el.barrePrix.hasAttribute('data-barre-prix-seul')) {
        venteBarre += t.laPaire;
        if (remise(n) > 0) venteBarre += ', ' + argent(prixActuel);
      }
      el.barrePrix.textContent = venteBarre;
    }
    if (el.barreTaille) {
      var choisie = pilules.filter(function (p) { return p.getAttribute('aria-pressed') === 'true'; })[0];
      el.barreTaille.textContent = choisie
        ? t.taille + choisie.textContent.trim() + t.modifier
        : t.choisis;
    }
    /* Le tiroir montre les paires réellement au panier, pas des cases anonymes. */
    for (var i = 0; i < el.cases.length; i++) {
      var c = el.cases[i];
      if (i < n) {
        c.setAttribute('data-pleine', '');
        var src = etat.images[i];
        var img = c.querySelector('img');
        if (src && (!img || img.getAttribute('data-src') !== src)) {
          c.innerHTML = '';
          img = new Image();
          img.src = src;
          img.alt = '';
          img.loading = 'lazy';
          img.setAttribute('data-src', src);
          c.appendChild(img);
        } else if (!src && img) {
          c.innerHTML = '';
        }
      } else {
        c.removeAttribute('data-pleine');
        if (c.firstChild) c.innerHTML = '';
      }
    }

    if (el.compte) {
      el.compte.textContent = n + ' ' + motDe(n);
    }

    /* Avancement vers le palier suivant. v43 : 0, 3, 5, 7 puis 10. */
    var bornes = [0, 3, 5, 7, 10];
    var precedent = 0, prochain = 10;
    for (var b = 0; b < bornes.length; b++) { if (bornes[b] <= n) precedent = bornes[b]; else { prochain = bornes[b]; break; } }
    var part = n >= 10 ? 1 : (n - precedent) / (prochain - precedent);
    if (part < 0) part = 0;
    if (part > 1) part = 1;
    [el.marche, el.barreJauge].forEach(function (j) {
      if (!j) return;
      var barre = j.querySelector('span');
      if (barre) barre.style.transform = 'scaleX(' + part.toFixed(3) + ')';
      if (n >= 10) j.setAttribute('data-complet', ''); /* v43 : complet au meilleur palier (10), avant 4 */
      else j.removeAttribute('data-complet');
    });

    /* Les vignettes gardent leur prix de vente : un prix conditionnel sur une carte
       que l'on peut cliquer ailleurs serait faux dès qu'on quitte cette page. */
    vignettes.forEach(function (v) {
      var pl = parseInt(v.getAttribute('data-plein') || '0', 10);
      if (pl) v.textContent = argent(pl);
    });
  }

  /* Le badge du header est rendu par la section « cart-counter » : on la redemande au
     serveur et on remplace son bloc. Sans ça, la pastille reste au chiffre de l'arrivée
     sur la page, et le client croit que son ajout n'a pas pris. */
  /* ⚠️ 28/09/2026 (v27) : les sections se demandent à la RACINE DE LA LANGUE (/fr/, /de/…),
     jamais à « / ». Sur « / » Shopify rend la section en anglais : le header affichait « CART »
     après un ajout, et le tiroir du thème, jamais rafraîchi, s'ouvrait vide (« C'est un peu vide
     ici ») jusqu'au rechargement. On redemande donc le compteur ET le corps du tiroir, d'un coup. */
  function racineLangue() {
    var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return r && r.charAt(r.length - 1) === '/' ? r : (r ? r + '/' : '/');
  }
  function rafraichirCompteur() {
    var tiroir = document.querySelector('cart-drawer');
    var ids = ['cart-counter'];
    var aRendre = [];
    try { aRendre = (tiroir && tiroir.getSectionsToRender && tiroir.getSectionsToRender()) || []; } catch (e) { aRendre = []; }
    aRendre.forEach(function (s) { if (ids.indexOf(s.section) < 0) ids.push(s.section); });
    return fetch(racineLangue() + '?sections=' + ids.join(','), { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data) return;
        if (tiroir && tiroir.renderContents && aRendre.length) {
          try {
            /* false : on rafraîchit sans ouvrir, la fiche garde son propre retour visuel. */
            tiroir.renderContents({ sections: data }, false);
            if (typeof updateFreeShipping === 'function') updateFreeShipping();
            document.dispatchEvent(new CustomEvent('cart:updated'));
          } catch (e) {}
        }
        if (!data['cart-counter']) return;
        var cible = document.getElementById('shopify-section-cart-counter');
        if (!cible) {
          /* Le thème peut rendre le compteur par un snippet sans enveloppe de section :
             dans ce cas on vise le lien du panier et on remplace son contenu. */
          var lien = document.querySelector('#cart-counter .header__utils-link--icon, [data-cart-link] .header__utils-link--icon');
          if (!lien) return;
          var bac = document.createElement('div');
          bac.innerHTML = data['cart-counter'];
          /* v64 (24/10/2026, Nicolas : l'icône du compte passe sur le R du logo après un ajout au panier) : on remet le
             contenu rendu par le serveur TEL QUEL (icône emballée dans .icon-with-text + pastille). Avant, on ne gardait
             que les enfants de .icon-with-text : le libellé « Panier » sortait de son enveloppe, devenait visible,
             élargissait le panier de 32 à 86 px et poussait l'icône du compte sur le logo. */
          var neufs = Array.prototype.slice.call((bac.querySelector('.shopify-section') || bac).childNodes);
          if (neufs.length) lien.replaceChildren.apply(lien, neufs);
          return;
        }
        var enveloppe = document.createElement('div');
        enveloppe.innerHTML = data['cart-counter'];
        var remplacant = enveloppe.firstElementChild;
        if (remplacant) cible.replaceWith(remplacant);
      })
      .catch(function () { /* le compteur n'est pas vital : on ne casse pas l'ajout pour lui */ });
  }

  function lirePanier() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        if (!c) { rendre(); return; }
        /* ⚠️ LES COFFRETS NE COMPTENT PAS (27/09/2026). Mesuré au panier : 1 coffret + 1 paire = 0 € de
           remise, les 4 remises « Mix & Match » ne portent pas sur les packs. Les compter faisait dire au
           tiroir « Cinq paires, la sixième met tout le tiroir à 11,18 € » à un panier qui n'aurait rien eu.
           Un coffret est reconnu à son titre (« Pack 3x… », « Pack 5x… », « Pack 2x Pilates… »). */
        var estCoffret = function (it) { return /^pack\b/i.test(it.product_title || '') || it.product_type === 'Cadeau'; }; /* v40 : le sac offert n'est pas une paire */
        etat.paires = (c.items || []).reduce(function (s, it) { return s + (estCoffret(it) ? 0 : it.quantity); }, 0);
        /* Une image par paire, dans l'ordre du panier, plafonnée aux six emplacements.

           ⚠️ Ne PAS filtrer par famille ici. Nicolas, 21/09/2026 : « si c'est moi qui avais mis
           dans mon panier une collection hiver, c'est bon, dans le panier il y a ça ». Le sac de
           studio n'est pas une recommandation, il montre le panier RÉEL, et une paire d'hiver
           doit s'y voir telle quelle. La règle de cloisonnement porte uniquement sur ce qu'on
           RECOMMANDE : le rail « Compléter le sac », les vignettes et les suggestions. */
        var imgs = [];
        (c.items || []).forEach(function (it) {
          if (estCoffret(it)) return;
          var url = it.featured_image && it.featured_image.url ? it.featured_image.url : (it.image || '');
          var petite = url ? url.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') : '';
          for (var k = 0; k < it.quantity && imgs.length < 6; k++) imgs.push(petite);
        });
        etat.images = imgs;
        rendre();
        /* Franchir un palier se voit : le tiroir respire une fois, pas davantage. */
        var palier = etat.paires >= 6 ? 6 : etat.paires >= 4 ? 4 : etat.paires >= 3 ? 3 : etat.paires >= 2 ? 2 : 0;
        if (el.tiroir && palier > etat.dernierPalier) {
          el.tiroir.removeAttribute('data-palier');
          void el.tiroir.offsetWidth;
          el.tiroir.setAttribute('data-palier', '');
          setTimeout(function () { el.tiroir.removeAttribute('data-palier'); }, 700);
        }
        etat.dernierPalier = palier;
      })
      .catch(function () { rendre(); });
  }

  function ajouter(varianteId, bouton) {
    if (!varianteId) {
      if (el.erreur) el.erreur.hidden = false;
      var p = racine.querySelector('.psv2__tailles');
      if (p && p.scrollIntoView) p.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    if (el.erreur) el.erreur.hidden = true;
    if (bouton) bouton.setAttribute('data-occupe', '');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: varianteId, quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('ajout refusé');
        return lirePanier();
      })
      .then(function () {
        if (bouton) {
          var avant = bouton.textContent;
          bouton.textContent = t.ajoute;
          bouton.setAttribute('data-fait', '');
          setTimeout(function () {
            bouton.textContent = avant;
            bouton.removeAttribute('data-fait');
          }, 900);
        }
        rafraichirCompteur();
      })
      .catch(function () {
        if (el.erreur) { el.erreur.textContent = t.erreur; el.erreur.hidden = false; }
      })
      .then(function () {
        if (bouton) bouton.removeAttribute('data-occupe');
      });
  }

  pilules.forEach(function (p) {
    p.setAttribute('aria-pressed', 'false');
    p.addEventListener('click', function () {
      if (p.hasAttribute('disabled')) return;
      pilules.forEach(function (q) { q.setAttribute('aria-pressed', 'false'); });
      p.setAttribute('aria-pressed', 'true');
      etat.variante = p.getAttribute('data-psv2-variante');
      etat.prixVariante = parseInt(p.getAttribute('data-prix') || plein, 10);
      if (el.erreur) el.erreur.hidden = true;
      rendre();
      /* 03/10/2026 (v33, Nicolas) : « quand on clique sur la taille, ça l'ajoute, il ne faut pas réappuyer sur
         Ajouter ». Le toucher d'une taille ajoute donc une paire tout de suite, retour visuel sur le bouton
         principal. Sauf la présélection automatique (une seule taille dispo) : là, rien ne part au panier. */
      if (!p._psAuto && racine.hasAttribute('data-tap-ajoute')) ajouter(etat.variante, boutons[0]); /* v59 : sinon taille + bouton Ajouter = 2 paires */
    });
  });

  /* Une seule taille disponible : on la choisit pour l'acheteur, ça supprime un obstacle (SANS l'ajouter). */
  var dispo = pilules.filter(function (p) { return !p.hasAttribute('disabled'); });
  if (dispo.length === 1) { dispo[0]._psAuto = true; dispo[0].click(); dispo[0]._psAuto = false; }

  boutons.forEach(function (b) {
    b.addEventListener('click', function () { ajouter(etat.variante, b); });
  });
  /* 03/10/2026 (v31) : « + Ajouter » du rail « Compléter le sac » ajoutait la PREMIERE taille
     disponible sans rien demander (Nicolas : « on ne sait pas si c'est la bonne »). Il ouvre
     maintenant la fenetre de choix de taille de assets/mm-taille-ajout.js, avec la taille deja au
     panier presentee comme « Votre taille » (sinon celle choisie sur cette fiche). L ajout et le
     rafraichissement de la bulle et du tiroir sont faits par la fenetre ; ici on relit le panier
     pour le sac de la fiche et on affiche « Ajouté » sur le bouton.
     Si la fenetre n est pas chargee (fichier absent), on garde l ancien ajout direct. */
  rapides.forEach(function (b) {
    b.addEventListener('click', function () {
      var vignette = b.closest('.psv2__vignette') || b.parentNode;
      var choisie = pilules.filter(function (q) { return q.getAttribute('aria-pressed') === 'true'; })[0];
      var ouvert = typeof window.__mmChoisirTaille === 'function' && window.__mmChoisirTaille(vignette, {
        indice: choisie ? choisie.textContent.trim() : null,
        apres: function () {
          lirePanier();
          var avant = b.textContent;
          b.textContent = t.ajoute;
          b.setAttribute('data-fait', '');
          setTimeout(function () { b.textContent = avant; b.removeAttribute('data-fait'); }, 900);
        }
      });
      if (!ouvert) ajouter(b.getAttribute('data-psv2-rapide'), b);
    });
  });

  /* La jauge de galerie suit le doigt au lieu d'afficher un numéro qui saute. */
  if (el.galerie && el.jaugeGalerie) {
    var largeurJauge = 1 / Math.max(1, racine.querySelectorAll('.psv2__photo').length);
    el.jaugeGalerie.style.width = (largeurJauge * 100).toFixed(2) + '%';
    var attente = false;
    el.galerie.addEventListener('scroll', function () {
      if (attente) return;
      attente = true;
      requestAnimationFrame(function () {
        var max = el.galerie.scrollWidth - el.galerie.clientWidth;
        var r = max > 0 ? el.galerie.scrollLeft / max : 0;
        var course = (1 / largeurJauge - 1) * r;
        el.jaugeGalerie.style.transform = 'translateX(' + (course * 100).toFixed(2) + '%)';
        attente = false;
      });
    }, { passive: true });
  }

  /* Une seule observation pour les apparitions et pour les jauges qui se remplissent. */
  var aObserver = Array.prototype.slice.call(racine.querySelectorAll('.psv2__reveal, [data-psv2-vue]'));
  if ('IntersectionObserver' in window && aObserver.length) {
    var oeil = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.setAttribute('data-vu', '');
        oeil.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    aObserver.forEach(function (n) { oeil.observe(n); });
  } else {
    aObserver.forEach(function (n) { n.setAttribute('data-vu', ''); });
  }

  rendre();
  lirePanier();
})();
